import { CalendarView } from "PFApp/booking/types";

export const PINS_LIMIT = 200;
export const INITIAL_MAX_CALENDAR_RANGE_MONTHS = 3;
export const DEFAULT_PAGE = 1;
export const DEFAULT_WORKFORCE_VIEW = CalendarView.Compressed;
